import { render, staticRenderFns } from "./TableLegalEntities.vue?vue&type=template&id=4f0a0f62&"
import script from "./TableLegalEntities.vue?vue&type=script&lang=js&"
export * from "./TableLegalEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports